import { render, staticRenderFns } from "./francemap.vue?vue&type=template&id=20be5d8e&scoped=true"
import script from "./francemap.vue?vue&type=script&lang=js"
export * from "./francemap.vue?vue&type=script&lang=js"
import style0 from "./francemap.vue?vue&type=style&index=0&id=20be5d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be5d8e",
  null
  
)

export default component.exports